export const statusProps = ['hidden', 'value', 'disabled', 'checked', 'selected', 'readOnly'];
